import { ControlId, ControlItem } from './controlCenter.types';

export const DEFAULT_CONTROL_ORDER: ControlId[] = [
  'theme',
  'versions',
  'quick-notes',
  'account',
  'calendar',
  'night-mode',
  'focus-mode',
  'fireflies-level',
  'snow-pile',
  'snow-level',
  'developer-test',
];

// Note: The order above places account and focus-mode buttons
// in the top section (row 2), filling the 4-column grid nicely:
// Row 1: theme (2) + versions (2) = 4 cols
// Row 2: quick-notes (2) + account (1) + focus-mode (1) = 4 cols
// Row 3: developer-test (1) + ... = continues

export const CONTROL_DEFINITIONS: Record<ControlId, ControlItem> = {
  theme: { id: 'theme', type: 'pill', colSpan: 2, condition: 'always' },
  versions: { id: 'versions', type: 'pill', colSpan: 2, condition: 'always' },
  'quick-notes': { id: 'quick-notes', type: 'pill', colSpan: 2, condition: 'always' },
  account: { id: 'account', type: 'round', colSpan: 1, condition: 'always' },
  'focus-mode': { id: 'focus-mode', type: 'round', colSpan: 1, condition: 'always' },
  'night-mode': { id: 'night-mode', type: 'round', colSpan: 1, condition: 'always' },
  calendar: { id: 'calendar', type: 'round', colSpan: 1, condition: 'always' },
  'developer-test': { id: 'developer-test', type: 'round', colSpan: 1, condition: 'developer' },
  'snow-pile': { id: 'snow-pile', type: 'pill', colSpan: 2, condition: 'snow' },
  'snow-level': { id: 'snow-level', type: 'slider', colSpan: 2, condition: 'snow' },
  'fireflies-level': { id: 'fireflies-level', type: 'slider', colSpan: 2, condition: 'always' },
};
